/* @flow */

import { Component } from 'react';

type Props = {
  children: Object => any,
  storageKey: string,
  storageMedium?: string,
};

type State = {
  value: ?string,
};

class LocalStorageWrapper extends Component<Props, State> {
  static defaultProps = {
    storageMedium: 'localStorage',
  };

  constructor(props: Props) {
    super(props);

    const storage = props.storageMedium && window[props.storageMedium];

    this.state = {
      value: storage ? storage.getItem(props.storageKey) : null,
    };
  }

  handleChange = (value: string) => {
    const { storageKey, storageMedium } = this.props;

    this.setState(
      {
        value,
      },
      () => {
        if (window[storageMedium]) {
          window[storageMedium].setItem(storageKey, value);
        }
      },
    );
  };

  render() {
    const { children } = this.props;
    const { value } = this.state;
    return children({
      onChange: this.handleChange,
      value,
    });
  }
}

export default LocalStorageWrapper;